// ### AdobeHTML5Auth
//
// Using Adobe's AccessEnabler JS.

'use strict';

var AdobeBaseAuth = require('./adobebaseauth');
var App = require('./app');
var ENV = require('./env');
var _ = require('./vendor/underscore');
var _logger = require('./logger');
var Util = require('./util');


var AdobeHTML5Auth = AdobeBaseAuth.extend({
	type: 'html5',
	PRODUCTION_ACCESS_ENABLER_URL: window.location.protocol + '//' + App.ADOBE_ENTITLEMENT_PRODUCTION_HOST + '/entitlement/AccessEnabler.js',
	STAGING_ACCESS_ENABLER_URL: window.location.protocol + '//' + App.ADOBE_ENTITLEMENT_STAGING_HOST + '/entitlement/AccessEnabler.js',
	PLATFORM_PROPERTY: 'html5',

	getSelectedProvider: function (callback, context) {
		_logger.log('AdobeHTML5Auth:getSelectedProvider');

		if (!_.isFunction(callback)) {
			_logger.error('getSelectedProvider requires an async callback');
			throw new Error('AdobeHTML5Auth::getSelectedProvider requires an async callback');
		}

		this.once('selectedProvider', callback, context);

		// make async request; the result will show up in the `selectedProvider` callback
		_logger.info('Adobe:call - getSelectedProvider');
		this.accessEnabler.getSelectedProvider();
	},

	setProviderDialogURL: function (/*url*/) {
		_logger.log('AdobeHTML5Auth:setProviderDialogURL');
		// no Adobe method defined for HTML5
	},

	externalizeCallbacks: function () {
		_logger.log('AdobeHTML5Auth:externalizeCallbacks');

		// this takes all the internal methods for adobe callbacks and
		// exposes them to the global scope so adobe can access them
		this._super();

		window.entitlementLoaded = _.bind(this._adobeCallback_entitlementLoaded, this);
		window.selectedProvider  = _.bind(this._adobeCallback_selectedProvider, this);
	},

	_adobeCallback_entitlementLoaded: function () {
		_logger.info('Adobe:callback - entitlementLoaded');

		// set a pointer to Adobe's accessEnabler object
		this.accessEnabler = window.accessEnabler;

		this._adobeLoaded();
	},

	_adobeCallback_selectedProvider: function (result) {
		_logger.info('Adobe:callback - selectedProvider', arguments);

		result = this._validateSelectedProvider(result);

		// provide async result for HTML AccessEnabler
		this.emit('selectedProvider', result);
	},

	init: function (options) {
		_logger.log('AdobeHTML5Auth:init', arguments);

		this._super(options);

		this.configuredEnv = options.vendorEnv;

		this.accessEnablerUrl = (
			this.getUrlForEnv(ENV.getVendorOverrideParam())
			|| options.adobeJsUrl
			|| this.getUrlForEnv(options.vendorEnv)
			|| this.PRODUCTION_ACCESS_ENABLER_URL
		);
	},

	install: function () {
		_logger.log('AdobeHTML5Auth:install');

		this._super();

		Util.loadScript(this.accessEnablerUrl);
	}

});


module.exports = AdobeHTML5Auth;
